import { useState , useEffect } from "react";
import { motion } from "framer-motion";
import { database } from "../scripts/firebaseConfig";
import { ref, get } from "firebase/database";

function Ads({baseURL}) {

  const [adds, setAdds] = useState([]);

  useEffect(() => {
    fetch(baseURL+"posts")
      .then((res) => res.json())
      .then((data) => {
        setAdds(data);
      });
  }, []);

  const AppearDown = {
      initial: { y: "100px", opacity: 0 },
      whileInView: { y: 0, opacity: 1 },
      transition: { duration: 1, delay: 0.2 },
    };

  return (
  <div className="shop">
    {adds.length === 0 ? (
      <p>No hay anuncios disponibles.</p>
    ) : (
      adds.map((ad) => (
        <motion.div key={ad.id} {...AppearDown} className="add">
          <img src={ad.image} alt="Imagen" draggable={false} />
          <h4>{ad.name}</h4>
          <p>{ad.description}</p>
          <a
            href="https://wa.me/+523315741580"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>Más info...</button>
          </a>
        </motion.div>
      ))
    )}
  </div>
);

}

export default Ads;